<template>
    <div class="survey-detail-container">
        <div class="survey-title">患者满意度调查问卷</div>
        <div class="survey-description">
            <p>尊敬的患者：</p>
            <p>
                您好！欢迎来到我院就诊，为进一步提升医疗服务质量，改善您的就医体验，现诚挚邀请您参与本次满意度调查。您的每一条反馈都将成为我们优化服务的重要依据，问卷采用匿名形式，数据仅用于统计分析，恳请您客观真实填写。</p>
        </div>

        <van-form @submit="onSubmit">
            <div class="survey-section">
                <div class="section-title">一、基本信息</div>
                <div class="question-item">
                    <div class="question-text">1. 您的性别：</div>
                    <van-radio-group v-model="surveyData.gender" class="option-group" :disabled="readOnly">
                        <van-radio name="1">男</van-radio>
                        <van-radio name="2">女</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">2. 您的年龄段：</div>
                    <van-radio-group v-model="surveyData.ageRange" class="option-group" :disabled="readOnly">
                        <van-radio name="18岁以下">18岁以下</van-radio>
                        <van-radio name="18-30岁">18-30岁</van-radio>
                        <van-radio name="31-50岁">31-50岁</van-radio>
                        <van-radio name="51-65岁">51-65岁</van-radio>
                        <van-radio name="65岁以上">65岁以上</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>3. 您的就诊类型：</div>
                    <van-radio-group v-model="surveyData.visitType" class="option-group" :disabled="readOnly">
                        <van-radio name="门诊">门诊</van-radio>
                        <van-radio name="住院">住院</van-radio>
                        <van-radio name="急诊">急诊</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>4. 您本次就诊的科室：</div>
                    <van-field class="custom-disabled" v-model="surveyData.department" placeholder="请输入科室" :disabled="readOnly" />
                </div>
            </div>

            <div class="survey-section">
                <div class="section-title">二、诊疗环节评价</div>
                <div class="sub-section-title">（一）挂号服务</div>
                <div class="question-item">
                  <div class="question-text"><span class="must">* </span>1. 您对医院挂号渠道的便捷性评价：</div>
                    <van-radio-group v-model="surveyData.registrationChannelConvenience" class="option-group" :disabled="readOnly">
                        <van-radio name="非常便捷">非常便捷</van-radio>
                        <van-radio name="便捷">便捷</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不便捷">不便捷</van-radio>
                        <van-radio name="非常不便捷">非常不便捷</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>2. 您对挂号等待时间的满意度：</div>
                    <van-radio-group v-model="surveyData.registrationWaitTimeSatisfaction" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="sub-section-title">（二）检查服务</div>
                <div class="question-item">
                    <div class="question-text">1. 您对检查项目预约流程的便捷性评价：</div>
                    <van-radio-group v-model="surveyData.checkupAppointmentConvenience" class="option-group" :disabled="readOnly">
                        <van-radio name="非常便捷">非常便捷</van-radio>
                        <van-radio name="便捷">便捷</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不便捷">不便捷</van-radio>
                        <van-radio name="非常不便捷">非常不便捷</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">2. 您对检验查血等待时间的满意度：</div>
                    <van-radio-group v-model="surveyData.bloodTestWaitTimeSatisfaction" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">3. 您对超声检查等待时间的满意度：</div>
                    <van-radio-group v-model="surveyData.ultrasoundWaitTimeSatisfaction" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">4. 您对放射检查（DR或CT）等待时间的满意度：</div>
                    <van-radio-group v-model="surveyData.radiologyWaitTimeSatisfaction" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">5. 您对检查科室医务人员的服务态度评价：</div>
                    <van-radio-group v-model="surveyData.checkupStaffAttitude" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">6. 您对检查结果出具及时性的满意度：</div>
                    <van-radio-group v-model="surveyData.checkupResultTimeliness" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>

                <div class="sub-section-title">（三）诊疗服务</div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>1. 您对接诊医生的服务态度评价：</div>
                    <van-radio-group v-model="surveyData.doctorAttitude" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>2. 您对医生解释病情、治疗方案及注意事项的清晰程度评价：</div>
                    <van-radio-group v-model="surveyData.doctorExplanationClarity" class="option-group" :disabled="readOnly">
                        <van-radio name="非常清晰">非常清晰</van-radio>
                        <van-radio name="清晰">清晰</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不清晰">不清晰</van-radio>
                        <van-radio name="非常不清晰">非常不清晰</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>3. 您对治疗效果的满意度：</div>
                    <van-radio-group v-model="surveyData.treatmentEffectSatisfaction" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>

                <div class="sub-section-title">（四）住院服务（住院患者填写）</div>
                <div class="question-item">
                    <div class="question-text">1. 您对住院手续办理流程的便捷性评价：</div>
                    <van-radio-group v-model="surveyData.admissionConvenience" class="option-group" :disabled="readOnly">
                        <van-radio name="非常便捷">非常便捷</van-radio>
                        <van-radio name="便捷">便捷</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不便捷">不便捷</van-radio>
                        <van-radio name="非常不便捷">非常不便捷</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">2. 您对病房环境的评价：</div>
                    <van-radio-group v-model="surveyData.wardEnvironment" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">3. 您对护士的服务态度评价：</div>
                    <van-radio-group v-model="surveyData.nurseAttitude" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">4. 您对出院手续办理便捷性及出院指导的满意度：</div>
                    <van-radio-group v-model="surveyData.dischargeConvenience" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>

                <div class="sub-section-title">（五）取药服务</div>
                <div class="question-item">
                    <div class="question-text">1. 您对取药等待时间的满意度：</div>
                    <van-radio-group v-model="surveyData.pharmacyWaitTimeSatisfaction" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text">2. 您对药房工作人员服务态度的评价：</div>
                    <van-radio-group v-model="surveyData.pharmacyStaffAttitude" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>

            </div>


            <div class="survey-section">
                <div class="section-title">三、整体评价</div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>1. 您对医院就医环境的评价：</div>
                    <van-radio-group v-model="surveyData.hospitalEnvironment" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>2. 您对医院标识指引的清晰程度评价：</div>
                    <van-radio-group v-model="surveyData.hospitalSignageClarity" class="option-group" :disabled="readOnly">
                        <van-radio name="非常清晰">非常清晰</van-radio>
                        <van-radio name="清晰">清晰</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不清晰">不清晰</van-radio>
                        <van-radio name="非常不清晰">非常不清晰</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>3. 您对医院的整体服务满意度：</div>
                    <van-radio-group v-model="surveyData.overallSatisfaction" class="option-group" :disabled="readOnly">
                        <van-radio name="非常满意">非常满意</van-radio>
                        <van-radio name="满意">满意</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不满意">不满意</van-radio>
                        <van-radio name="非常不满意">非常不满意</van-radio>
                    </van-radio-group>
                </div>
                <div class="question-item">
                    <div class="question-text"><span class="must">* </span>4. 您是否会向亲友推荐本院就诊：</div>
                    <van-radio-group v-model="surveyData.recommendationWillingness" class="option-group" :disabled="readOnly">
                        <van-radio name="非常愿意">非常愿意</van-radio>
                        <van-radio name="愿意">愿意</van-radio>
                        <van-radio name="不确定">不确定</van-radio>
                        <van-radio name="不愿意">不愿意</van-radio>
                        <van-radio name="非常不愿意">非常不愿意</van-radio>
                    </van-radio-group>
                </div>
            </div>

            <div class="survey-section">
                <div class="section-title">四、意见与建议</div>
                <div class="question-item">
                    <div class="question-text">1. 您认为本院在医疗服务中最需要改进的方面是（可多选）：</div>
                    <van-checkbox-group v-model="surveyData.improvementsNeeded" class="option-group" :disabled="readOnly">
                        <van-checkbox name="挂号便捷性" shape="square">挂号便捷性</van-checkbox>
                        <van-checkbox name="就诊等待时间" shape="square">就诊等待时间</van-checkbox>
                        <van-checkbox name="检查检验等待时间" shape="square">检查检验等待时间</van-checkbox>
                        <van-checkbox name="取药等待时间" shape="square">取药等待时间</van-checkbox>
                        <van-checkbox name="医务人员服务态度" shape="square">医务人员服务态度</van-checkbox>
                        <van-checkbox name="检查和治疗效果" shape="square">检查和治疗效果</van-checkbox>
                        <van-checkbox name="医院就医环境" shape="square">医院就医环境</van-checkbox>
                        <van-checkbox name="医院标识指引" shape="square">医院标识指引</van-checkbox>
                    </van-checkbox-group>
                </div>
                <div class="question-item">
                    <van-field class="custom-disabled" v-model="surveyData.improvementsNeededOther" label="其他：" placeholder="请输入其他需要改进的方面" :disabled="readOnly"/>
                </div>
                <div class="question-item">
                    <div class="question-text">2. 您对本院医疗服务还有其他具体意见或建议：</div>
                    <van-field class="custom-disabled" v-model="surveyData.otherSuggestions" type="textarea"
                               placeholder="请输入您的意见或建议" rows="3" :disabled="readOnly" />
                </div>
                <div class="question-item">
                    <div class="question-text">3. 为了后续和您沟通相关反馈信息，请自愿留下您的联系方式：</div>
                    <van-field class="custom-disabled" v-model="surveyData.contactInfo" placeholder="请输入您的联系方式" :disabled="readOnly"/>
                </div>
            </div>

            <div class="survey-section" v-if="readOnly && survey.feedBack">
                <div class="section-title">五、平台反馈</div>
                <div class="question-item">
                    <van-field class="custom-disabled" v-model="survey.feedBack" type="textarea"
                               placeholder="请输入您的意见或建议" rows="3" :disabled="readOnly" />
                </div>
            </div>

            <div style="margin: 16px;" v-if="!readOnly">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
    import {Form, Field, RadioGroup, Radio, Button, Checkbox, CheckboxGroup, Toast} from 'vant'
    import surveyListService from '../../service/surveyList.service'

    export default {
        name: 'SurveyDetail',
        components: {
            [Form.name]: Form,
            [Field.name]: Field,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Button.name]: Button,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Toast.name]: Toast // Add Toast to components
        },
        data() {
            return {
                survey: {},
                voucher: {},
                hospital: {},
                readOnly: false,
                // 问卷调查内容
                surveyData: {
                    gender: '',
                    ageRange: '',
                    visitType: '',
                    department: '',
                    registrationChannelConvenience: '',
                    registrationWaitTimeSatisfaction: '',
                    checkupAppointmentConvenience: '',
                    bloodTestWaitTimeSatisfaction: '',
                    ultrasoundWaitTimeSatisfaction: '',
                    radiologyWaitTimeSatisfaction: '',
                    checkupStaffAttitude: '',
                    checkupResultTimeliness: '',
                    doctorAttitude: '',
                    doctorExplanationClarity: '',
                    treatmentEffectSatisfaction: '',
                    admissionConvenience: '',
                    wardEnvironment: '',
                    nurseAttitude: '',
                    dischargeConvenience: '',
                    pharmacyWaitTimeSatisfaction: '',
                    pharmacyStaffAttitude: '',
                    hospitalEnvironment: '',
                    hospitalSignageClarity: '',
                    overallSatisfaction: '',
                    recommendationWillingness: '',
                    improvementsNeeded: [],
                    improvementsNeededOther: '',
                    otherSuggestions: '',
                    contactInfo: ''
                }
            }
        },
        created() {
            const { survey, voucher, hospital, readOnly } = this.$route.params;
            this.readOnly = readOnly
            this.survey = survey
            this.voucher = voucher
            this.hospital = hospital
            if (readOnly && survey) {
                this.surveyData = JSON.parse(survey.content)
            }
        },
        methods: {
            onSubmit() {
                const mandatoryFields = [
                  {field: 'visitType', message: '请选择：您的就诊类型'},
                    {field: 'registrationChannelConvenience', message: '请完成：挂号渠道便捷性评价'},
                    {field: 'registrationWaitTimeSatisfaction', message: '请完成：挂号等待时间满意度评价'},
                    // {field: 'checkupAppointmentConvenience', message: '请选择检查项目预约流程便捷性评价'},
                    // {field: 'bloodTestWaitTimeSatisfaction', message: '请选择检验查血等待时间满意度'},
                    // {field: 'ultrasoundWaitTimeSatisfaction', message: '请选择超声检查等待时间满意度'},
                    // {field: 'radiologyWaitTimeSatisfaction', message: '请选择放射检查等待时间满意度'},
                    // {field: 'checkupStaffAttitude', message: '请选择检查科室医务人员服务态度评价'},
                    // {field: 'checkupResultTimeliness', message: '请选择检查结果出具及时性满意度'},
                    {field: 'doctorAttitude', message: '请完成：接诊医生服务态度评价'},
                    {field: 'doctorExplanationClarity', message: '请完成：医生解释病情清晰程度评价'},
                    {field: 'treatmentEffectSatisfaction', message: '请完成：治疗效果满意度评价'},
                    // {field: 'pharmacyWaitTimeSatisfaction', message: '请选择取药等待时间满意度'},
                    // {field: 'pharmacyStaffAttitude', message: '请选择药房工作人员服务态度评价'},
                    {field: 'hospitalEnvironment', message: '请完成：医院就医环境评价'},
                    {field: 'hospitalSignageClarity', message: '请完成：医院标识指引清晰程度评价'},
                    {field: 'overallSatisfaction', message: '请完成：医院整体服务满意度评价'},
                    {field: 'recommendationWillingness', message: '请选择：是否会向亲友推荐本院就诊？'}
                ];

                for (const item of mandatoryFields) {
                    if (!this.surveyData[item.field] || (Array.isArray(this.surveyData[item.field]) && this.surveyData[item.field].length === 0)) {
                      Toast({
                        message: item.message,
                        position: 'bottom',
                      });
                        return;
                    }
                }
                surveyListService.submitSurvey({
                    // 医院信息
                    hosId: this.hospital.hospitalId,
                    hosName: this.hospital.hospitalName,
                    // 患者信息
                    cardNo: this.voucher.cardNo,
                    cardType: this.voucher.cardType,
                    patientName: this.voucher.holderName,
                    // 医院整体满意度
                    degree: this.surveyData.overallSatisfaction,
                    // 整个问卷填写内容的json字符串
                    content: JSON.stringify(this.surveyData)
                }).then((res)=> {
                    Toast.success('问卷提交成功！');
                    this.$router.back()
                }).catch(()=> {})
            }
        }
    }
</script>

<style scoped>
    .survey-detail-container {
        padding: 15px;
        background-color: #f5f5f5;
    }

    .survey-title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
    }

    .survey-description {
        font-size: 14px;
        color: #666;
        margin-bottom: 20px;
        line-height: 1.6;
    }

    .survey-section {
        background-color: #fff;
        padding: 15px;
        margin-bottom: 15px;
        border-radius: 5px;
    }

    .section-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        border-left: 3px solid #409eff;
        padding-left: 10px;
    }

    .sub-section-title {
        font-size: 14px;
        font-weight: bold;
        margin-top: 15px;
        margin-bottom: 10px;
        color: #333;
    }

    .question {
        margin-bottom: 15px;
        position: relative;
    }

    .question p {
        font-size: 14px;
        margin-bottom: 8px;
    }

    .question-item {
        margin-bottom: 15px;
    }

    .question-text {
        font-size: 15px;
        color: #333;
        margin-bottom: 10px;
        font-weight: 500;
    }
    .must {
      color: red;
    }

    .option-group {
        display: flex;
        flex-wrap: wrap;
    }

    .option-group .van-radio,
    .option-group .van-checkbox {
        flex: 0 0 calc(33.33% - 10px); /* 3 items per line, adjust 10px for spacing */
        margin-right: 10px; /* Spacing between items */
        margin-bottom: 10px; /* Spacing between rows */
    }

    .option-group .van-radio:nth-child(3n),
    .option-group .van-checkbox:nth-child(3n) {
        margin-right: 0; /* No right margin for the 3rd item in a row */
    }


    /deep/ .option-group .van-radio__label--disabled {
        color: #000;
    }
    /deep/ .option-group .van-radio__icon--disabled.van-radio__icon--checked .van-icon {
        color: #fff;
        background-color: #1989fa;
        border-color: #1989fa;
    }
    /deep/ .option-group .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
        color: #fff;
        background-color: #1989fa;
        border-color: #1989fa;
    }

    /deep/ .option-group .van-checkbox__label--disabled {
        color: #000;
    }
    /deep/ .custom-disabled .van-field__control[disabled] {
        color: #000;
        -webkit-text-fill-color: #000;
    }

</style>



// WEBPACK FOOTER //
// SurveyDetail.vue?5051c1c1